import React, { forwardRef } from "react";

import { EditableInput } from "./editableinput.jsx";
export { EDITABLES_SIZE } from "./editableinput.jsx";

export const EditableMultiLine = forwardRef(function EditableMultiLine(
  props,
  ref
) {
  return <EditableInput multiline={true} ref={ref} {...props} />;
});

EditableMultiLine.propTypes = EditableInput.propTypes;
